import { customTV } from '../../utils/tailwind';
export const bar = customTV({
    base: 'border-thin border-border-contrast dark:border-border-contrast-dark bg-background-contrast dark:bg-background-contrast-dark mx-8 flex h-32 rounded-md',
});
export const pageButton = customTV({
    base: 'mx-2 h-32 min-w-32 items-center border-none px-4',
});
